var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoreVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.1424C12.5523 13.1424 13 12.7117 13 12.1804C13 11.649 12.5523 11.2183 12 11.2183C11.4477 11.2183 11 11.649 11 12.1804C11 12.7117 11.4477 13.1424 12 13.1424Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.40782C12.5523 6.40782 13 5.97708 13 5.44573C13 4.91438 12.5523 4.48364 12 4.48364C11.4477 4.48364 11 4.91438 11 5.44573C11 5.97708 11.4477 6.40782 12 6.40782Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.8771C12.5523 19.8771 13 19.4463 13 18.915C13 18.3836 12.5523 17.9529 12 17.9529C11.4477 17.9529 11 18.3836 11 18.915C11 19.4463 11.4477 19.8771 12 19.8771Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreVertical);
export default __webpack_public_path__ + "static/media/icon-more-vertical.808731ee980b84167f77a471f446c8f1.svg";
export { ForwardRef as ReactComponent };